/**
 * Composant pour initialiser l'authentification au démarrage
 * Charge le profil si un token existe
 */
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useGetProfileCoachQuery } from '../store';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { logout } from '../store/slices/authSlice';

export const AuthInitializer = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const [isInitialized, setIsInitialized] = useState(false);

  // Charger le profil si authentifié
  const { isLoading, isError, error } = useGetProfileCoachQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (!isAuthenticated) {
      // Pas de token, on peut afficher l'app
      setIsInitialized(true);
      return;
    }

    if (isError) {
      // ✅ CORRECTION : Déconnecter UNIQUEMENT si 401 (token invalide)
      const status = error?.status;
      
      if (status === 401) {
        // Token invalide ou expiré (et refresh a échoué)
        console.error('❌ Token invalide (401), déconnexion');
        dispatch(logout());
      } else {
        // Autre erreur (500, timeout, réseau, etc.) : garder l'utilisateur connecté
        console.warn('⚠️ Erreur de chargement du profil (non-401), utilisateur gardé connecté');
        console.error('Profile error:', error);
      }
      
      setIsInitialized(true);
      return;
    }

    if (!isLoading) {
      // Profil chargé avec succès
      setIsInitialized(true);
    }
  }, [isAuthenticated, isLoading, isError, error, dispatch]);

  // Afficher un loader minimal pendant l'initialisation (seulement au démarrage)
  if (!isInitialized && isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f9fafb'
      }}>
        <div style={{ textAlign: 'center' }}>
          <svg 
            className="animate-spin" 
            style={{ 
              width: '40px', 
              height: '40px', 
              margin: '0 auto 16px',
              color: '#0d9488'
            }} 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              style={{ opacity: 0.25 }} 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            ></circle>
            <path 
              style={{ opacity: 0.75 }} 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <div style={{ fontSize: '16px', color: '#6b7280' }}>
            Chargement...
          </div>
        </div>
      </div>
    );
  }

  return children;
};
